export default {
    errorcodes : []
}